import { render, staticRenderFns } from "./MarketCartTableVariantTitle.vue?vue&type=template&id=35e8eb35&"
import script from "./MarketCartTableVariantTitle.vue?vue&type=script&lang=js&"
export * from "./MarketCartTableVariantTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports